import './_countdown-timer.scss';
import component from './countdown-timer';

export default component;
